import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DefineUserInterface } from "../interfaces/defineUserInterface";
import { FieldsetHarukiSelectOption, toDataURL } from "mm-ui";
import { SaveWidgetConfig, ColumnWidget } from "../models/homepage";
import { InputInterface } from "../interfaces/inputInterface";
import { sortDefineUser } from "../components/cms/content/create-homepage/widgets-configuration/birth-widget/birth-widget.component";
import { Page } from "../models/page";

import * as lodash from 'lodash';
import deepdash from "deepdash";
import { Validators } from "@angular/forms";
import { featureType } from "../interfaces/featuresConfig";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom, lastValueFrom } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
const _ = deepdash(lodash);


@Injectable({
  providedIn: 'root'
})
export class Utils {

  constructor(
    private translate: TranslateService,
    private http: HttpClient,
    protected sanitizer: DomSanitizer
  ) {

  }

  hasStorage(name) {
    return !!this.getStorage(name);
  }
  setStorage(name, obj) {
    localStorage.setItem(name, obj);
  }

  getStorage(name) {
    return localStorage.getItem(name);
  }

  removeStorage(name) {
    localStorage.removeItem(name);
  }

  async renderImage(src, type) {

    const token = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    const imageBlob = await lastValueFrom(this.http.get(src, { headers, responseType: 'blob' }))
    let a = toDataURL(imageBlob)
    let x = ''
    return a.then((data: any) => {
      if (data) {

        x = data.result
        console.log(x)
        return x
      }
    });


    // console.log({imageBlob})

    // switch(type){
    //   case 'image': return a.then((data:any) => {
    //     console.log({data:data.result});
    //     return data.result;
    //   });
    //   case 'background': return a.then((data:any) => {
    //     console.log({data:data.result})
    //     return this.sanitizer.bypassSecurityTrustStyle(`url(${data.result})`);
    //   });

    // }
  }

}


export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

//export const ipRangePattern = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\/)(([1-9][0-9]{1}|1[0-9]{1}|2[0-4][0-9]|25[0-5]))$'
export const ipRangePattern = '^(\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\/(3[0-2]|[1-2][0-9]|[0-9]))'

export function cleanStylesFromDom() {
  const head: HTMLHeadElement = document.getElementsByTagName('head')[0];
  const styles: HTMLCollectionOf<HTMLStyleElement> | [] = head.getElementsByTagName('style');

  for (let i: number = 0; i < styles.length; i++) {
    head.removeChild(styles[i]);
  }
}

export const Alphabets = [...Array(26)].map((_, y) => String.fromCharCode(y + 65));

export function filterRecursive(obj: any[], recursiveAtribute: string, attribute: string, value: any) {
  let newObj = obj.map(item => {
    if (item[attribute] === value) {
      if (item[recursiveAtribute]) {
        let recursiveItem = filterRecursive(item[recursiveAtribute], recursiveAtribute, attribute, value)
        return { ...item, [recursiveAtribute]: recursiveItem }
      }
    } else {
      return false
    }
  })

  return newObj.filter(item => typeof item == 'object');
}

export function mapRecursive(obj: any[], recursiveAtribute: string, mapFunction: (item: any) => any,): any {
  let newObj = obj.map(item => {
    let newItem = mapFunction(item);
    if (newItem[recursiveAtribute]) {
      newItem[recursiveAtribute] = mapRecursive(newItem[recursiveAtribute], recursiveAtribute, mapFunction);
    }
    return newItem
  })

  return newObj
}

export function filter(array: Array<any>, att: string) {
  return array.map(item => item[att])
}

export function isOnLogin(): boolean {
  let route = window.location.pathname;
  return route.includes('login') || route === '/' || route.includes('set_password') || route.includes('client-activation');
}

export function getWidgetFromConfig(config: SaveWidgetConfig, row: number, column: number): ColumnWidget {
  return config[`column${column}Widgets`][row];
}

export function eventFire(el, etype) {
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    let evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}

export const corporateFieldsAttr = [
  'grouperFieldOne',
  'grouperFieldTwo',
  'grouperFieldThree',
  'grouperFieldFour',
  'grouperFieldFive'
]

export const featureModules = {
  [featureType.glossary]: 'glossary',
  [featureType.flowsurvey]: 'flowsurvey',
  [featureType.spreadsheet]: 'spreadsheet'
}

export function convertTreeToList(root, childAttr) {
  let stack = [], array = [], hashMap = {};

  array.push(root);
  stack.push(root);
  while (stack.length !== 0) {
    let node = stack.pop();
    if (node[childAttr]?.length === 0) {
      array.push(node);
    } else {
      for (let i = node[childAttr].length - 1; i >= 0; i--) {
        stack.push(node[childAttr][i]);
        array.push(node[childAttr][i]);
      }
    }
  }

  return array;
}

export function scrollIntoAlert(className) {
  var custom = document.querySelector(className);
  return custom && custom.scrollIntoView({ behavior: "smooth" });
}

export function scrollIntoView(element: Element) {
  let rect = element.getBoundingClientRect();

  if (window && element['offsetTop']) {
    window.scrollTo({
      top: element['offsetTop'],
      behavior: 'smooth'
    })
  }
}

export function copyMessage(val: string) {
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);

}

export function filterCorporateFields(fields: DefineUserInterface): DefineUserInterface {
  let filterdFields = {} as DefineUserInterface;

  let keys = Object.keys(fields);
  keys.forEach(key => {
    if (corporateFieldsAttr.includes(key)) {
      filterdFields[key] = fields[key];
    }
  })

  let { id, completedProfileEdition, completedProfileView, completedSearchConfig, completedSensitiveFields, completedUserDefinition } = fields
  filterdFields = { ...filterdFields, ...{ id, completedProfileEdition, completedProfileView, completedSearchConfig, completedSensitiveFields, completedUserDefinition } }

  return filterdFields
}

export function trackByFn(index, item) {
  return index;
}

export function findAndReplace(newItem: any, items: any[], attr: string) {
  for (var i = 0; i < items.length; i++) {
    if (items[i][attr] == newItem[attr]) {
      items[i] = newItem;
    } else if (items[i].items) {
      items[i] = findAndReplace(newItem, items[i].items, attr);
    }
  }

  return items;
}

export function createDefineUserObjectFromArray(defineUser: InputInterface[]): DefineUserInterface {
  let fieldsWithAdditionalFields = {};
  fieldsWithAdditionalFields = defineUser.reduce((acc, cur) => ({ ...acc, ...getInputFieldObj(cur) }), {})

  let fields = { id: 'valid' } as DefineUserInterface;
  fields.additionalFields = [];
  let addFields = [];
  let keys = Object.keys(fieldsWithAdditionalFields);
  keys.forEach(key => {
    if (key.includes('additionalField')) {
      addFields.push(fieldsWithAdditionalFields[key]);
    } else {
      fields[key] = fieldsWithAdditionalFields[key];
    }
  })

  fields.additionalFields = addFields.sort((a, b) => {
    if (a.label.toLowerCase() > b.label.toLowerCase()) {
      return 1;
    }
    if (a.label.toLowerCase() < b.label.toLowerCase()) {
      return -1;
    }
    // a must be equal to b
    return 0;
  })

  return fields
}

export function getInputFieldObj(obj: InputInterface) {

  let fieldNameSplit = obj.attribute.split('.');
  let fieldName = fieldNameSplit[fieldNameSplit.length - 1];
  return { [fieldName]: obj }
}

export function sortFieldsetHarukiOptionsByLabel(a: FieldsetHarukiSelectOption, b: FieldsetHarukiSelectOption) {
  if (a.label.toLowerCase() > b.label.toLowerCase()) {
    return 1;
  }
  if (a.label.toLowerCase() < b.label.toLowerCase()) {
    return -1;
  }
  // a must be equal to b
  return 0;
}

export const validatorHttpUrl = Validators.pattern('^(?:http(s)?:\/\/)(.)*');

export const widgetList = [
  {
    value: "birthdays",
    label: "widgets.birthdays.title",
    type: 'reusable'
  }, {
    value: "notepad",
    label: "widgets.notepad.title",
    type: 'unique'
  }, {
    value: "user_search",
    label: "widgets.user_search.title",
    type: 'reusable'
  },
  {
    value: "calendar",
    label: "widgets.calendar.title",
    type: 'reusable'
  },
  {
    value: "page_favorites",
    label: "widgets.favorites.title",
    type: 'unique'
  },
  /*{
    value: "contacts",
    label: "widgets.contacts.title",
    type: 'unique'
  },*/
  {
    value: "last_updates",
    label: "widgets.last_updates.title",
    type: 'reusable'
  }, {
    value: 'dynamic_links',
    label: 'Links Dinâmicos',
    type: 'reusable'
  }, {
    value: "poster",
    label: "widgets.poster.title",
    type: 'reusable'
  }, {
    value: 'page_list',
    label: "Listagem de páginas",
    type: 'reusable'
  }, {
    value: "html",
    label: "widgets.html.title",
    type: 'reusable'
  }, {
    value: "hiring_birthdays",
    label: "widgets.hiring_birthdays.title",
    type: 'reusable'
  }, {
    value: 'navigation_history',
    label: 'widgets.navigation_history.title',
    type: 'reusable'
  }, {
    value: "most_accessed_pages",
    label: "widgets.most_accessed_pages.title",
    type: "reusable"
  }, {
    value: "internal_page_list",
    label: "widgets.internal_page_list.title",
    type: "reusable"
  },
  {
    value: "area_search",
    label: "widgets.area_search.title",
    type: null
  },
  {
    value: "tags",
    label: "widgets.tags.title",
    type: "reusable"
  }
]

export const pagesMock: any[] = [{ "lastModifiedDate": "15\/08\/2019 16:48", "lastModifiedById": "685c22a0-686f-4cc8-9c8a-7d665d2e36ea", "coverImage": { "fileName": "background6.jpg", "mediaUrl": "http:\/\/media.tst.mmcafe.corp\/rails\/active_storage\/disk\/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdDRG9JYTJWNVNTSWRWRGh0Wkc5aFRGRnpZV2RDYjNNeGVUWXpSMWxHTm5OU0Jqb0dSVlE2RUdScGMzQnZjMmwwYVc5dVNTSkphVzVzYVc1bE95Qm1hV3hsYm1GdFpUMGlZbUZqYTJkeWIzVnVaRFl1YW5Cbklqc2dabWxzWlc1aGJXVXFQVlZVUmkwNEp5ZGlZV05yWjNKdmRXNWtOaTVxY0djR093WlVPaEZqYjI1MFpXNTBYM1I1Y0dWSklnOXBiV0ZuWlM5cWNHVm5CanNHVkE9PSIsImV4cCI6IjIwMjAtMDgtMjdUMjA6NDY6NDIuNzM2WiIsInB1ciI6ImJsb2Jfa2V5In19--a6c429b07192e4213bcd6b2477da1642f079863c\/background6.jpg?content_type=image%2Fjpeg&disposition=inline%3B+filename%3D%22background6.jpg%22%3B+filename%2A%3DUTF-8%27%27background6.jpg", "lastModifiedDate": "15\/08\/2019 16:48", "id": "41d9e9e5-de10-44cf-8f24-7ba7899300c7", "type": "COVER_IMAGE", "creationDate": "15\/08\/2019 16:48", "mediaId": "ed00433c-980b-46ad-b717-ec14db83b7c8", "contentType": "image\/jpeg" }, "description": "Precisa de atendimento exclusivo, ágil e fácil na área de embarque? Conheça o nosso espaço", "durations": { "lastModifiedDateDurationInHours": null, "lastModifiedDateDurationInDays": null, "lastModifiedDateDurationInYears": null, "publishingDateDurationInYears": 0, "publishingDateDurationInMinutes": 17338, "publishingDateDurationInDays": 12, "lastModifiedDateDurationInMinutes": null, "publishingDateDurationInHours": 288, "publishingDateDurationInWeeks": 1, "publishingDateDurationInMonths": 0, "lastModifiedDateDurationInMonths": null, "lastModifiedDateDurationInWeeks": null }, "id": "7b476f4d-9e66-40ce-8c58-70d2967cce53", "title": "Serviços GOL", "publishingDate": "22\/05\/2019 00:00", "creationDate": "22\/05\/2019 14:52", "createdById": "685c22a0-686f-4cc8-9c8a-7d665d2e36ea" }, { "lastModifiedDate": "05\/08\/2019 11:10", "lastModifiedById": "5b93c24a-9542-40ff-8c29-db7d48b67cce", "coverImage": { "fileName": "background2.jpg", "mediaUrl": "http:\/\/media.tst.mmcafe.corp\/rails\/active_storage\/disk\/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdDRG9JYTJWNVNTSWRjRUZXYjBOS1lXVXlRMHRSYzI0NWFXVnBRMk5HVFhKaUJqb0dSVlE2RUdScGMzQnZjMmwwYVc5dVNTSkphVzVzYVc1bE95Qm1hV3hsYm1GdFpUMGlZbUZqYTJkeWIzVnVaREl1YW5Cbklqc2dabWxzWlc1aGJXVXFQVlZVUmkwNEp5ZGlZV05yWjNKdmRXNWtNaTVxY0djR093WlVPaEZqYjI1MFpXNTBYM1I1Y0dWSklnOXBiV0ZuWlM5cWNHVm5CanNHVkE9PSIsImV4cCI6IjIwMjAtMDgtMjdUMjA6NDY6NDIuODMxWiIsInB1ciI6ImJsb2Jfa2V5In19--fe09c1572c5c0bea1748543b5f22b47461589a89\/background2.jpg?content_type=image%2Fjpeg&disposition=inline%3B+filename%3D%22background2.jpg%22%3B+filename%2A%3DUTF-8%27%27background2.jpg", "lastModifiedDate": "05\/08\/2019 11:10", "id": "b01b9cd4-4927-4bb7-9256-89278a3d5d43", "type": "COVER_IMAGE", "creationDate": "05\/08\/2019 11:10", "mediaId": "4a50f9f2-30ed-446d-bda5-00e1f790c865", "contentType": "image\/jpeg" }, "description": "Veja aqui todas as informações sobre as documentações ISO. ", "durations": { "lastModifiedDateDurationInHours": null, "lastModifiedDateDurationInDays": null, "lastModifiedDateDurationInYears": null, "publishingDateDurationInYears": 0, "publishingDateDurationInMinutes": 32076, "publishingDateDurationInDays": 22, "lastModifiedDateDurationInMinutes": null, "publishingDateDurationInHours": 534, "publishingDateDurationInWeeks": 3, "publishingDateDurationInMonths": 0, "lastModifiedDateDurationInMonths": null, "lastModifiedDateDurationInWeeks": null }, "id": "d49ab9ae-8726-4710-a4f0-09f61339186e", "title": "Atendimento", "publishingDate": "22\/05\/2019 00:00", "creationDate": "22\/05\/2019 14:55", "createdById": "685c22a0-686f-4cc8-9c8a-7d665d2e36ea" }, { "lastModifiedDate": "24\/07\/2019 10:26", "lastModifiedById": "3628ac4a-6daa-47dd-86e3-62369e7727d0", "coverImage": { "fileName": "shutterstock_381676807.jpg", "mediaUrl": "http:\/\/media.tst.mmcafe.corp\/rails\/active_storage\/disk\/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdDRG9JYTJWNVNTSWRRbTlsZHpOcFdUUXpTbFZWU0VSM09WbDROMDQwU0hkbkJqb0dSVlE2RUdScGMzQnZjMmwwYVc5dVNTSmZhVzVzYVc1bE95Qm1hV3hsYm1GdFpUMGljMmgxZEhSbGNuTjBiMk5yWHpNNE1UWTNOamd3Tnk1cWNHY2lPeUJtYVd4bGJtRnRaU285VlZSR0xUZ25KM05vZFhSMFpYSnpkRzlqYTE4ek9ERTJOelk0TURjdWFuQm5CanNHVkRvUlkyOXVkR1Z1ZEY5MGVYQmxTU0lQYVcxaFoyVXZhbkJsWndZN0JsUT0iLCJleHAiOiIyMDIwLTA4LTI3VDIwOjQ2OjQyLjkxOVoiLCJwdXIiOiJibG9iX2tleSJ9fQ==--f05e0bd98c74a6f302a682526f7cad5896e7b5c2\/shutterstock_381676807.jpg?content_type=image%2Fjpeg&disposition=inline%3B+filename%3D%22shutterstock_381676807.jpg%22%3B+filename%2A%3DUTF-8%27%27shutterstock_381676807.jpg", "lastModifiedDate": "06\/06\/2019 11:56", "id": "4b50d405-d96b-498c-9d5f-51621b15d16e", "type": "COVER_IMAGE", "creationDate": "29\/05\/2019 15:51", "mediaId": "b84e4b65-fc74-46ce-8739-79c5d4ae2964", "contentType": "image\/jpeg" }, "description": "Com a Gol você pode consultar tudo referente a sua viagem e muito mais! teste", "durations": { "lastModifiedDateDurationInHours": null, "lastModifiedDateDurationInDays": null, "lastModifiedDateDurationInYears": null, "publishingDateDurationInYears": 0, "publishingDateDurationInMinutes": 49400, "publishingDateDurationInDays": 34, "lastModifiedDateDurationInMinutes": null, "publishingDateDurationInHours": 823, "publishingDateDurationInWeeks": 4, "publishingDateDurationInMonths": 1, "lastModifiedDateDurationInMonths": null, "lastModifiedDateDurationInWeeks": null }, "id": "de321664-9d3e-452a-b242-6fac4c6cba49", "title": "Sua viagem", "publishingDate": "23\/05\/2019 00:00", "creationDate": "22\/05\/2019 14:40", "createdById": "685c22a0-686f-4cc8-9c8a-7d665d2e36ea" }, { "lastModifiedDate": "12\/07\/2019 10:21", "lastModifiedById": "3628ac4a-6daa-47dd-86e3-62369e7727d0", "coverImage": null, "description": "Veja aqui notícias e outras informações úteis sobre a GOL, os destinos que operamos, viagens de avião e o mercado da aviação.", "durations": { "lastModifiedDateDurationInHours": null, "lastModifiedDateDurationInDays": null, "lastModifiedDateDurationInYears": null, "publishingDateDurationInYears": 0, "publishingDateDurationInMinutes": 66685, "publishingDateDurationInDays": 46, "lastModifiedDateDurationInMinutes": null, "publishingDateDurationInHours": 1111, "publishingDateDurationInWeeks": 6, "publishingDateDurationInMonths": 1, "lastModifiedDateDurationInMonths": null, "lastModifiedDateDurationInWeeks": null }, "id": "b3ceb2d2-9602-4079-9d14-3d68eeae3eaf", "title": "GOL Informa!", "publishingDate": "23\/05\/2019 00:00", "creationDate": "23\/05\/2019 17:03", "createdById": "685c22a0-686f-4cc8-9c8a-7d665d2e36ea" }, { "lastModifiedDate": "07\/06\/2019 17:03", "lastModifiedById": "685c22a0-686f-4cc8-9c8a-7d665d2e36ea", "coverImage": null, "description": "Ser a 1º para todos é pensar em novos tempos todos os dias. Conheça nossa história de pioneirismo e toda a nossa estrutura!", "durations": { "lastModifiedDateDurationInHours": null, "lastModifiedDateDurationInDays": null, "lastModifiedDateDurationInYears": null, "publishingDateDurationInYears": 0, "publishingDateDurationInMinutes": 116683, "publishingDateDurationInDays": 81, "lastModifiedDateDurationInMinutes": null, "publishingDateDurationInHours": 1944, "publishingDateDurationInWeeks": 11, "publishingDateDurationInMonths": 2, "lastModifiedDateDurationInMonths": null, "lastModifiedDateDurationInWeeks": null }, "id": "f2dae06e-3aba-4495-923d-3408c7d96e93", "title": "A GOL", "publishingDate": "22\/05\/2019 00:00", "creationDate": "22\/05\/2019 14:54", "createdById": "685c22a0-686f-4cc8-9c8a-7d665d2e36ea" }]

export function getFieldLabel(attribute: string, profileData: DefineUserInterface) {
  if (profileData) {
    if (attribute.match(/additionalField/)) {
      return profileData.additionalFields
        .filter(field => field.attribute === attribute)
        .map(field => field.label)[0]
    } else {
      return Object.keys(profileData)
        .filter(field => profileData[field].attribute === attribute)
        .map(field => profileData[field].label)[0]
    }

  }
}

export function replace_last_comma_with_and(x) {
  let pos = x.lastIndexOf(',');
  if (pos != -1) {
    return x.substring(0, pos) + ' e' + x.substring(pos + 1);
  } else {
    return x
  }
}


export const hourMask = '00:00'
export const colorMask = '#AAAAAA'; //use with const hexaPattern and hexaRegExp
export const cpfMask = '000.000.000-00'
export const dateMask = '00/00/0000';
export const percentageMask = '000%';
export const rgMask = '00.000.000-A'
export const ipMask = '000.000.000.000';
export const hexaRegExp = new RegExp('\[a-zA-Z0-9\]');
export const specialCharacters = ['[', ']', '#']

export function replaceDateSlash(date: string) {
  let splitDate = date.split("/")
  return `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`
}

export function aspectRatio(width, height) {
  let aspectRatio = (width / height);
  return aspectRatio;
}

export function gotoTop(classCss?) {

  let tagClass = classCss ? classCss : '.mmp-nav-margin';
  let top = document.querySelector(tagClass);
  top && top.scrollIntoView({ behavior: 'smooth' });
}

export const statusOptions: Array<FieldsetHarukiSelectOption> = [{
  label: 'Ativo',
  value: 'ACTIVE'
},
{
  label: 'Afastado',
  value: 'AWAY'
},
{
  label: 'Desligado',
  value: 'OFF'
},
{
  label: 'Em férias',
  value: 'ON_VACATION'
}]

export const genderOptions: Array<FieldsetHarukiSelectOption> = [{
  value: 'F',
  label: 'Feminino'
},
{
  label: 'Masculino',
  value: 'M'
},
{
  label: 'Outros',
  value: 'O'
}]

export const socialOptions: Array<FieldsetHarukiSelectOption> = [{
  value: 'SOL',
  label: 'Solteiro'
},
{
  value: 'CAS',
  label: 'Casado'
},
{
  value: 'SEP',
  label: 'Separado'
},
{
  label: 'Divorciado',
  value: 'DIV'
},
{
  value: 'VIU',
  label: 'Viúvo'
}]

export const booleanOptions: Array<FieldsetHarukiSelectOption> = [
  {
    label: 'Sim',
    value: true
  }, {
    label: 'Não',
    value: false
  }
]

export function mediaExtension(type) {

  if (type.includes('pdf')) {
    return 'pdf'
  } else if (type.includes('sheet') || type.includes('excel') || type.includes('csv') || type.includes('xls') || type.includes('wps') || type.includes('xlsx')) {
    return 'xls'
  } else if (type.includes('text/plain') || type.includes('rtf') || type.includes('rtx')) {
    return 'txt'
  } else if (type.includes('word')) {
    return 'doc'
  } else if (type.includes('powerpoint') || type.includes('presentation')) {
    return 'ppt'
  } else if (type.includes('png')) {
    return 'png'
  } else if (type.includes('jpg') || type.includes('jpeg')) {
    return 'jpg'
  } else if (type.includes('tiff')) {
    return 'other'
  } else if (type.includes('rtf')) {
    return 'rtf'
  } else if (type.includes('gif')) {
    return 'gif'
  } else if (type.includes('bmp')) {
    return 'bmp'
  } else if (type.includes('csv')) {
    return 'csv'
  } else if (type.includes('gif')) {
    return 'gif'
  } else if (type.includes('mp4')) {
    return 'mp4'
  } else if (type.includes('mpeg')) {
    return 'mpeg'
  } else if (type.includes('x-msvideo')) {
    return 'avi'
  } else if (type.includes('wmv') || type.includes('x-ms-wmv')) {
    return 'wmv'
  }
  else if (type.includes('html')) {
    return 'html, htm'
  } else {
    return 'other'
  }

}

export function ordenate(a, b) {


  if (a.title > b.title) {
    return 1;
  }
  if (a.title < b.title) {
    return -1;
  }

  return 0;


}

export function whichProtocol() {
  let urlProtocol = window.location.protocol;
  if (urlProtocol.indexOf('https:') >= 0) {
    return 'https://'
  } else {
    return 'http://'
  }
}

export function verifyColorLightness(themeWrapper, hslColor) {

  let hsl = JSON.parse(hslColor)

  if (hsl && themeWrapper) {

    let h = hsl['h'] * 360;

    if (hsl['l'] > 0.75) {
      themeWrapper.style.setProperty('--navbar-subtitle-color', '#232327')
    } else {
      themeWrapper.style.setProperty('--navbar-subtitle-color', '#ffffff')
      if (h >= 50 && h <= 95 && hsl['l'] > 0.35) {
        themeWrapper.style.setProperty('--navbar-subtitle-color', '#232327')
      } else if (((h >= 45 && h < 50) || (h > 95 && h <= 185)) && hsl['l'] > 0.35) {
        if (hsl['s'] >= 0.8) {
          themeWrapper.style.setProperty('--navbar-subtitle-color', '#232327')
        }
      }
    }
  }

}

export function b64ToBLob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}
